const formatPhoneNumberToBEFormat = phone => {
	const digits = phone.match(/\d/g);

	return digits.join('');
};

export default formatPhoneNumberToBEFormat;
